import { BoGroupsListRequestInterface } from '../../../../interfaces/request/backoffice-groups/bo-groups-list-request-model/bo-groups-list-request-interface';

export class BoGroupsListRequestModel implements BoGroupsListRequestInterface {
  pageSize?: number | undefined;
  page?: number | undefined;

  constructor(init?: Partial<BoGroupsListRequestModel>) {
    Object.assign(this, init);
  }
}
